<template>
  <div>
    <hot-table
      ref="hotTableComponent"
      :colWidths="colWidths"
      :width="width"
      :height="height"
      :data="tb"
      :mergeCells="mergeCells"
      :cell="cell"
      :licenseKey="licenseKey"
    ></hot-table>
    <div style="padding-top: 10px; text-align: center">
      <el-button
        type="primary"
        size="mini"
        :loading="loading"
        @click="toDownLoad"
        >下载</el-button
      >
      <el-button type="primary" size="mini" :loading="loading" @click="print"
        >打印</el-button
      >
    </div>
  </div>
</template>

<script>
import { HotTable } from "@handsontable/vue";
export default {
  name: "index",
  components: {
    HotTable,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    report_yidong: {
      type: Number,
      required: true,
    },
  },
  data: function () {
    return {
      width: 1110,
      height: 570,
      tb: [],
      mergeCells: [],
      cell: [],
      licenseKey: "non-commercial-and-evaluation",
      loading: false,
      colWidths: 275,
      gyyqjbqkb: {
        id: "fa63bfdf-dca2-4a25-a719-327000841207",
        code: "jjyxadmin@lygyhlw.com",
        name: "西部智谷工业园",
        dwfzr: "",
        tjfzr: "",
        tbr: "",
        lxdh: "",
        tbrq: "2020-02-19",
        date_range: "2020-02",
        des: "",
        doc_id: "2266ccef-1cb0-4eac-886e-b19b7f06aefd",
        month_query: "02",
        year_query: "2020",
        quarter_query: "1",
      },
      tb_gyyqjbqkb1List: [],
      fileList: [],
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      const self = this;
      self.loading = true;
      //修改提交
      self.$axios
        .get("/business/data-insert/gyyqjbqkb", {
          params: {
            id: self.id,
          },
        })
        .then((res) => {
          self.gyyqjbqkb = res.data.gyyqjbqkb;
          self.tb_gyyqjbqkb1List = res.data.tb_gyyqjbqkb1List;
          self.initOption(res.data.gyyqjbqkb, res.data.tb_gyyqjbqkb1List);
          self.loading = false;
        })
        .catch((err) => {
          console.log("error", err);
          self.loading = false;
        });
    },
    initOption(gyyqjbqkb, tb_gyyqjbqkb1List) {
      const self = this;
      self.tb = [];
      const row1 = ["工业园区基本情况表", "", "", ""];
      const row2 = ["主要指标", "单位", "1-本期止累计", "上年同期"];
      self.tb.push(row1);
      self.tb.push(row2);
      tb_gyyqjbqkb1List.forEach((tb_gyyqjbqkb1) => {
        const temp = [
          tb_gyyqjbqkb1.zyzb,
          tb_gyyqjbqkb1.unit,
          tb_gyyqjbqkb1.bqzlj,
          tb_gyyqjbqkb1.sntq,
        ];
        self.tb.push(temp);
      });
      const row22 = [
        "单位负责人:",
        gyyqjbqkb.dwfzr,
        "统计负责人:",
        gyyqjbqkb.tjfzr,
      ];
      const row23 = ["填表人:", gyyqjbqkb.tbr, "联系电话:", gyyqjbqkb.lxdh];
      const row24 = ["报出日期:", gyyqjbqkb.tbrq, "", ""];
      self.tb.push(row22);
      self.tb.push(row23);
      self.tb.push(row24);

      self.initMergeCells();
      self.initcell();
    },
    initMergeCells() {
      const self = this;
      self.mergeCells = [];
      let row0 = { row: 0, col: 0, rowspan: 1, colspan: 4 };
      let row24 = { row: 23, col: 1, rowspan: 1, colspan: 3 };
      self.mergeCells.push(row0);
      self.mergeCells.push(row24);
    },
    initcell() {
      const self = this;
      self.cell = [];
      self.cell.push({
        row: 0,
        col: 0,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell.push({
        row: 1,
        col: 0,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell.push({
        row: 1,
        col: 1,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell.push({
        row: 1,
        col: 2,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell.push({
        row: 1,
        col: 3,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      for (let i = 2; i < 21; i++) {
        self.cell.push({
          row: i,
          col: 0,
          className: "htCenter htMiddle",
          readOnly: true,
        });
        self.cell.push({
          row: i,
          col: 1,
          className: "htCenter htMiddle",
          readOnly: true,
        });
        if (i == 2) {
          //工业总产值
          self.cell.push({
            row: i,
            col: 2,
            className: "htCenter htMiddle",
            validator: self.validatorGyzczThis,
            type: "numeric",
            numericFormat: { pattern: "0.00" },
          });
          self.cell.push({
            row: i,
            col: 3,
            className: "htCenter htMiddle",
            validator: self.validatorGyzczLast,
            type: "numeric",
            numericFormat: { pattern: "0.00" },
          });
        } else if (i == 3) {
          //工业销售产值
          self.cell.push({
            row: i,
            col: 2,
            className: "htCenter htMiddle",
            validator: self.validatorGyxsczThis,
            type: "numeric",
            numericFormat: { pattern: "0.00" },
          });
          self.cell.push({
            row: i,
            col: 3,
            className: "htCenter htMiddle",
            validator: self.validatorGyxsczLast,
            type: "numeric",
            numericFormat: { pattern: "0.00" },
          });
        } else if (i == 5) {
          //营业收入
          self.cell.push({
            row: i,
            col: 2,
            className: "htCenter htMiddle",
            validator: self.validatorYysrThis,
            type: "numeric",
            numericFormat: { pattern: "0.00" },
          });
          self.cell.push({
            row: i,
            col: 3,
            className: "htCenter htMiddle",
            type: "numeric",
            numericFormat: { pattern: "0.00" },
          });
        } else if (i == 10) {
          //利润总额
          self.cell.push({
            row: i,
            col: 2,
            className: "htCenter htMiddle",
            validator: self.validatorLrzeThis,
            type: "numeric",
            numericFormat: { pattern: "0.00" },
          });
          self.cell.push({
            row: i,
            col: 3,
            className: "htCenter htMiddle",
            type: "numeric",
            numericFormat: { pattern: "0.00" },
          });
        } else if (i == 9) {
          //实缴税金
          self.cell.push({
            row: i,
            col: 2,
            className: "htCenter htMiddle",
            validator: self.validatorSjsjThis,
            type: "numeric",
            numericFormat: { pattern: "0.00" },
          });
          self.cell.push({
            row: i,
            col: 3,
            className: "htCenter htMiddle",
            type: "numeric",
            numericFormat: { pattern: "0.00" },
          });
        } else {
          self.cell.push({
            row: i,
            col: 2,
            className: "htCenter htMiddle",
            type: "numeric",
            numericFormat: { pattern: "0.00" },
          });
          self.cell.push({
            row: i,
            col: 3,
            className: "htCenter htMiddle",
            type: "numeric",
            numericFormat: { pattern: "0.00" },
          });
        }
      }

      self.cell.push({
        row: 21,
        col: 0,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell.push({
        row: 21,
        col: 2,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell.push({
        row: 22,
        col: 0,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell.push({
        row: 22,
        col: 2,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell.push({
        row: 23,
        col: 0,
        className: "htCenter htMiddle",
        readOnly: true,
      });
      self.cell.push({
        row: 23,
        col: 1,
        className: "htCenter htMiddle",
        readOnly: true,
      });
    },
    toDownLoad() {
      window.open(
        window.location.origin +
          "/api/business/data-insert/gyyqjbqkb/download?id=" +
          this.id
      );
    },
    print() {
      const self = this;
      self.loading = true;
      self.$axios
        .get("/business/data-insert/gyyqjbqkb/print", {
          params: {
            id: self.id,
          },
        })
        .then((res) => {
          var printWin = window.open("打印窗口", "_blank");
          printWin.document.write(res.msg);
          printWin.document.close();
          printWin.print();
          printWin.close();
          self.loading = false;
          console.log(res);
        })
        .catch((err) => {
          console.log("error", err);
          self.loading = false;
        });
    },
    validatorGyzczThis(value, callback) {
      //工业总产值本月
      const self = this;
      if (self.report_yidong) {
        return callback(true);
      } else if (!/^[0-9]+\.?[0-9]*$/.test(value)) {
        return callback(false);
      }
      const gyzczThis = value;
      const gyzczLast = self.$refs.hotTableComponent.hotInstance.getDataAtCell(
        2,
        3
      ); //工业总产值去年本月;
      const gyxsczThis = self.$refs.hotTableComponent.hotInstance.getDataAtCell(
        3,
        2
      ); //工业销售产值;
      const message = "您所填的工业销售产值大于工业总产值!";
      const message1 = "您的工业总产值高于去年值30%!";
      setTimeout(function () {
        if (gyxsczThis > gyzczThis) {
          self.$message.warning(message);
          callback(false);
        } else if (gyzczThis > gyzczLast * 1.3) {
          self.$message.warning(message1);
          callback(false);
        } else {
          callback(true);
        }
      }, 1000);
    },
    validatorGyxsczThis(value, callback) {
      //工业销售产值本月
      const self = this;
      if (self.report_yidong) {
        return callback(true);
      } else if (!/^[0-9]+\.?[0-9]*$/.test(value)) {
        return callback(false);
      }
      const gyxsczThis = value;
      const gyxsczLast = self.$refs.hotTableComponent.hotInstance.getDataAtCell(
        3,
        3
      ); //工业销售产值去年本月;;
      const gyzczThis = self.$refs.hotTableComponent.hotInstance.getDataAtCell(
        2,
        2
      ); //工业总产值本月;
      const message = "您所填的工业销售产值大于工业总产值!";
      const message1 = "您的工业销售产值高于去年值30%!";
      setTimeout(function () {
        if (gyxsczThis > gyzczThis) {
          self.$message.warning(message);
          callback(false);
        } else if (gyxsczThis > gyxsczLast * 1.3) {
          self.$message.warning(message1);
          callback(false);
        } else {
          callback(true);
        }
      }, 1000);
    },
    validatorGyzczLast(value, callback) {
      //工业总产值去年本月
      const self = this;
      if (self.report_yidong) {
        return callback(true);
      } else if (!/^[0-9]+\.?[0-9]*$/.test(value)) {
        return callback(false);
      }
      const gyzczLast = value;
      const gyzczThis = self.$refs.hotTableComponent.hotInstance.getDataAtCell(
        2,
        2
      ); //工业总产值本月;
      const message = "您的工业总产值高于去年值30%!";
      setTimeout(function () {
        if (gyzczThis > gyzczLast * 1.3) {
          self.$message.warning(message);
          callback(false);
        } else {
          callback(true);
        }
      }, 1000);
    },
    validatorGyxsczLast(value, callback) {
      //工业销售产值去年本月
      const self = this;
      if (self.report_yidong) {
        return callback(true);
      } else if (!/^[0-9]+\.?[0-9]*$/.test(value)) {
        return callback(false);
      }
      const gyxsczLast = value;
      const gyxsczThis = self.$refs.hotTableComponent.hotInstance.getDataAtCell(
        3,
        2
      ); //工业销售产值本月;
      const message = "您的工业销售产值高于去年值30%!";
      setTimeout(function () {
        if (gyxsczThis > gyxsczLast * 1.3) {
          self.$message.warning(message);
          callback(false);
        } else {
          callback(true);
        }
      }, 1000);
    },
    validatorYysrThis(value, callback) {
      //营业收入本月
      const self = this;
      if (self.report_yidong) {
        return callback(true);
      } else if (!/^[0-9]+\.?[0-9]*$/.test(value)) {
        return callback(false);
      }
      const yysrThis = value;
      const lrzeThis = self.$refs.hotTableComponent.hotInstance.getDataAtCell(
        10,
        2
      ); //利润总额本月;
      const message = "您所填的利润总额大于营业收入!";
      setTimeout(function () {
        if (lrzeThis > yysrThis) {
          self.$message.warning(message);
          callback(false);
        } else {
          callback(true);
        }
      }, 1000);
    },
    validatorLrzeThis(value, callback) {
      //利润总额本月;
      const self = this;
      if (self.report_yidong) {
        return callback(true);
      } else if (!/^[0-9]+\.?[0-9]*$/.test(value)) {
        return callback(false);
      }
      const lrzeThis = value;
      const sjsjThis = self.$refs.hotTableComponent.hotInstance.getDataAtCell(
        9,
        2
      ); //实缴税金本月
      const yysrThis = self.$refs.hotTableComponent.hotInstance.getDataAtCell(
        5,
        2
      ); //营业收入本月
      const message = "您所填的利润总额大于营业收入!";
      const message1 = "您所填的税金大于利润总额!";
      setTimeout(function () {
        if (lrzeThis > yysrThis) {
          self.$message.warning(message);
          callback(false);
        } else if (sjsjThis > lrzeThis) {
          self.$message.warning(message1);
          callback(false);
        } else {
          callback(true);
        }
      }, 1000);
    },
    validatorSjsjThis(value, callback) {
      //实缴税金本月;
      const self = this;
      if (self.report_yidong) {
        return callback(true);
      } else if (!/^[0-9]+\.?[0-9]*$/.test(value)) {
        return callback(false);
      }
      const sjsjThis = value;
      const lrzeThis = self.$refs.hotTableComponent.hotInstance.getDataAtCell(
        10,
        2
      ); //利润总额本月
      const message = "您所填的利润总额大于营业收入!";
      setTimeout(function () {
        if (sjsjThis > lrzeThis) {
          self.$message.warning(message);
          callback(false);
        } else {
          callback(true);
        }
      }, 1000);
    },
  },
};
</script>
<style>
.wtHider {
  margin: auto;
}
</style>